// extracted by mini-css-extract-plugin
export default {"paddingVertical":"QuantityText_paddingVertical","contentBlockSmallTitle":"QuantityText_contentBlockSmallTitle","paddingHorisontal":"QuantityText_paddingHorisontal"};